import { styled, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';

export const HeaderW = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const TopRow = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  width: 100%;
`;

export const SignInLink = styled(NavLink)`
  font-size: 24px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.info.main};
  cursor: pointer;
  text-decoration: none;
  line-height: 24px;

  @media (max-width: 1023px) {
    font-size: 18px;
  }
`;

export const LogoRow = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;

  @media (max-width: 1023px) {
    margin-top: 16px;
  }
`;

export const LogoTextW = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const Wordmark = styled(Typography)`
  font-weight: 800;
  font-size: 26px;
  line-height: 28px;
  letter-spacing: 0.06em;
  color: ${({ theme }) => theme.palette.primary.main};
`;

export const Tagline = styled(Typography)`
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.04em;
  color: ${({ theme }) => theme.palette.primary.p050};
`;
